import React from 'react';
import { protocolStructure, sampleMeta, sampleTimeline } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-114" data-mp="21naq2g858v3b">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="21mr8j0meo8pt">
        <Eyebrow data-id="element-116" data-mp="25ocgq8nzvyto">Look inside</Eyebrow>
        <SectionTitle data-id="element-117" data-mp="25nb2xwflgy89">
          See how a clinical <Mark data-id="element-118" data-mp="25qgr99gefw2x">session is organized</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-119" data-mp="1rvmv45cdovx3">
          From the functional baseline to manual work, active rehabilitation, and reassessment — every stage is laid
          out.
        </p>

        <article className="mt-8 overflow-hidden rounded-2xl border border-brand/10 bg-white shadow-xl" data-id="element-120" data-mp="1mxla3eve6miz">
          <header className="bg-brand p-5" data-id="element-121" data-mp="18xtsz59kwq0r">
            <p className="text-[10px] font-extrabold uppercase tracking-wider text-gold-light" data-id="element-122" data-mp="18z53dnxj4w0u">Example session</p>
            <h3 className="mt-1 text-base font-black uppercase text-white md:text-lg" data-id="element-123" data-mp="1dz9bapkdgifg">
              Standing & Weight-Transfer Preparation — 30 Minutes
            </h3>
          </header>
          <dl className="grid grid-cols-2 gap-px bg-brand/10 sm:grid-cols-3" data-id="element-124" data-mp="60t17gmfre0g">
            {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-125" data-mp="f20pr6z5h0hc">
                <dt className="text-[10px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-126" data-mp="f2k98s4g7wxh">{label}</dt>
                <dd className="mt-0.5 text-sm font-bold text-brand-deep" data-id="element-127" data-mp="3nfhslkuranr5">{value}</dd>
              </div>)}
          </dl>
          <div className="border-t border-brand/10 px-5 pt-4" data-id="element-128" data-mp="11q0279ktrxr">
            <p className="text-[11px] font-black uppercase tracking-wider text-brand" data-id="element-129" data-mp="142pt6lkt6ld">Example session timeline</p>
            <table className="mt-2 w-full text-left text-sm" data-id="element-130" data-mp="3seubjuiibaog">
              <thead className="sr-only" data-id="element-131" data-mp="34prvus7fnrwl">
                <tr data-id="element-132" data-mp="2zrzwjd4gl3id">
                  <th scope="col" data-id="element-133" data-mp="2zsi1cy56sq1w">Stage</th>
                  <th scope="col" data-id="element-134" data-mp="2zrq3fgo4ag8g">Time</th>
                </tr>
              </thead>
              <tbody data-id="element-135" data-mp="13o27pn4a5a2v">
                {sampleTimeline.map(([stage, time]) => <tr key={stage} className="border-b border-brand/10" data-id="element-136" data-mp="18n54kka3w9zr">
                    <th scope="row" className="py-2.5 pr-3 align-top font-semibold text-brand-deep" data-id="element-137" data-mp="1dewucslfubou">
                      {stage}
                    </th>
                    <td className="whitespace-nowrap py-2.5 text-right font-bold tabular-nums text-brand" data-id="element-138" data-mp="1hfgqbsu9z99e">{time}</td>
                  </tr>)}
                <tr data-id="element-139" data-mp="pokg6zzlnipt">
                  <th scope="row" className="py-3 pr-3 text-xs font-black uppercase tracking-wider text-brand-deep" data-id="element-140" data-mp="ppvguqxr0acp">
                    Total
                  </th>
                  <td className="whitespace-nowrap py-3 text-right font-black tabular-nums text-brand-deep" data-id="element-141" data-mp="ypigb76x3634">30 min</td>
                </tr>
              </tbody>
            </table>
            <p className="pb-4 text-xs italic leading-relaxed text-slate-600" data-id="element-142" data-mp="25873g5dwzyl9">
              Illustrative example. Treatment selection and timing must be adapted to each patient.
            </p>
          </div>
          <div className="border-t border-brand/10 bg-slate-50 px-5 py-4" data-id="element-143" data-mp="2f9rk773t8kz1">
            <p className="text-[11px] font-black uppercase tracking-wider text-brand-deep" data-id="element-144" data-mp="2fbuei3bzx09k">Each technique includes:</p>
            <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-145" data-mp="26hfqncdegheu">
              {protocolStructure.map(item => <li key={item} className="rounded-md border border-brand/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-700" data-id="element-146" data-mp="21i3833tk9wi2">
                  {item}
                </li>)}
            </ul>
          </div>
        </article>
      </div>
    </section>;
}